import { POST, postFile } from "../../index";

export const selectCarInsurance = (param) => POST("/v1/carInsurance/selectCarInsurance", param);
export const updateCarInsurance = (param) => POST("/v1/carInsurance/updateCarInsurance", param);
export const uploadCarInsurance = (param) => postFile("/v1/getExportExcel/uploadCarInsurance", param);
